// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player__vimeo[data-v-501fb085]{left:0;top:0;height:100%;width:100%;position:relative}[data-v-501fb085] iframe{border-radius:7px}", ""]);
// Exports
module.exports = exports;
